import React, { ReactNode, ReactNodeArray } from "react";
import { CardBox, CardTitle, CardContent, CardBadge, CardSubTitle } from "./styles";

interface Props {
  titulo: string;
  subTitulo?: string;
  label?: string;
  children: ReactNode | ReactNodeArray;
}

export const Card: React.FC<Props> = ({
  titulo,
  subTitulo,
  label,
  children
}) => {
  
  return (
    <CardBox>
      <CardTitle>
        {titulo}

        {label &&
          <CardBadge>{label}</CardBadge>
        }

        <br/>

        {subTitulo &&
          <CardSubTitle>
            {subTitulo}
          </CardSubTitle>
        }
      </CardTitle>
      
      <CardContent>
        {children}
      </CardContent>
    </CardBox>
  );
}